import { render, staticRenderFns } from "./MyTasksPopoverItem.vue?vue&type=template&id=1f45ac17&"
import script from "./MyTasksPopoverItem.vue?vue&type=script&lang=js&"
export * from "./MyTasksPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports